<template>
    <MainContent :title="'Generar invitaciones'">
        <template v-slot:header>
            <h3 class="card-title pb-3">Generar invitaciones para un evento</h3>
        </template>
        <template v-slot:content>
            <div v-if="!loading">
                <b-container>
                    <ContentOrLoading>
                        <Stepper
                            v-if="!loading"
                            ref="stepper"
                            :steps="steps" 
                        >
                            <template #pasoZona="{ changeStep }">
                                <PasoUnoInvitaciones
                                    :key="reloadComponents"
                                    :event_id="event_id"
                                    :sesion_id="sesion_id"
                                    :abono_id="abono_id"
                                    :place="evento?.place"
                                    :frontend="false"
                                    @terminado="zona => { finalizarPasoUno(zona); changeStep(); }"
                                />  
                            </template>
                            <template #pasoButacas="{ changeStep }">
                                <PasoDosInvitaciones
                                    :key="reloadComponents"
                                    :zona="zona"
                                    :event_id="event_id"
                                    :sesion_id="sesion_id"
                                    :abono_id="abono_id"
                                    :max_asientos="max_asientos"
                                    :frontend="false"
                                    @setSessionId="(sessionId, seats) => { session_id = sessionId; asientos = seats; changeStep() }"
                                    @cambiarZona="() => { cambiarZona(); changeStep(true); }"
                                />
                            </template>
                            <template #pasoDatos="{ changeStep }">
                                <PasoTresInvitaciones
                                    :key="reloadComponents"
                                    :zona="zona"
                                    :evento="evento"
                                    :sesion_id="String(sesion_id)"
                                    :session_id="session_id"
                                    :abonado="abonado"
                                    :asientos="asientos"
                                    :desactivar="loading"
                                    @guardarDatos="(payload, datos_abonado) => { guardarDatos(payload, datos_abonado); changeStep(); }"
                                    @borrarSesionAndCambiarPaso="() => { borrarSesionAndCambiarPaso(); changeStep(true); }"
                                />
                            </template>
                            <template #pasoResumen="{ changeStep }">
                                <PasoCuatroInvitaciones
                                    :key="reloadComponents"
                                    :session_id="session_id"
                                    :asientos="asientos"
                                    :desactivar="loading"
                                    :frontend="false"
                                    :pedidoInfo="pedidoInfo"
                                    @terminado="(_, terminosYCondiciones) => { procesarCompraPrecioCero(terminosYCondiciones); }"
                                    @volver="() => { changeStep(true) }"
                                />
                            </template>
                        </Stepper>
                    </ContentOrLoading>
                </b-container>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent';
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';
    import Stepper from '@/components/frontend/events/compra/components/Stepper';
    import PasoUnoInvitaciones from '@/components/frontend/perfil/invitaciones/PasoUnoInvitaciones';
    import PasoDosInvitaciones from '@/components/frontend/perfil/invitaciones/PasoDosInvitaciones';
    import PasoTresInvitaciones from '@/components/frontend/perfil/invitaciones/PasoTresInvitaciones';
    import PasoCuatroInvitaciones from '@/components/frontend/perfil/invitaciones/PasoCuatroInvitaciones';

    export default {
        props: {
            event_id: [String, Number],
            abono_id: [String, Number],
            sesion_id: [String, Number]
        },
        data() {
            return {
                loading: false,
                evento: null,
                invitaciones_abonado: null,
                reloadComponents: 1,
                zona: null,
                session_id: null,
                asientos: [],
                abonado: null,
                steps: [
                    { label: this.$t('perfil_invitaciones.zona'), slot: 'pasoZona' },
                    { label: this.$t('perfil_invitaciones.butacas'), slot: 'pasoButacas' },
                    { label: this.$t('perfil_invitaciones.rellenar_datos'), slot: 'pasoDatos' },
                    { label: this.$t('partido.resumen_compra'), slot: 'pasoResumen' }
                ],
                pedidoInfo: null
            }
        },
        computed : {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            max_asientos() {
                return Math.min(
                    this.evento?.invitaciones_restantes || 0, 
                    this.abonado?.invitaciones_abonado?.n_total_disponibles || 0
                );
            }
        },
        methods: {
            getEvento() {
                this.loading = true;

                const params = {
                    filters: {
                        evento_id: this.event_id
                    },
                    abonado_id: this.abono_id
                }

                this.$store.dispatch('BACK_ABONADOS_ABONO_LISTADO_INVITACIONES_EVENTOS', params).then(res => {
                    this.evento = res.data.data[0];
                }).finally(() => {
                    this.loading = false;
                })
            },
            getAbonado() {
                this.$store.dispatch('BACK_ABONADOS_SHOW', { abonado_id: this.abono_id }).then(res => {
                    const abonado_raw = res.data.data
                    this.abonado = {
                        id: abonado_raw.id,
                        name: abonado_raw.name,
                        apellidos: abonado_raw.surnames,
                        dni: abonado_raw.dni,
                        email: abonado_raw.email,
                        telefono: abonado_raw.telefono,
                        cp: abonado_raw.cp,
                        edad: this.calcularEdad(abonado_raw.fecha_nacimiento),
                        email_confirmation: abonado_raw.email,
                        tipoDocumentoSeleccionado: this.detectarTipoDocumento(abonado_raw.dni.trim().toUpperCase()),
                        invitaciones_abonado: abonado_raw.invitaciones_abonado,
                        properties: {}
                    }
                });
            },
            finalizarPasoUno(zona) {
                this.zona = zona;
            },
            cambiarZona() {
                this.zona = null;
                this.reloadComponents++;
            },
            guardarDatos(payload, datos_abonado) {

                const validarTelefonos = () => {
                    if (!datos_abonado.telefono || datos_abonado.telefono.trim() === '') {
                        this.$toast.error('El teléfono del abonado es obligatorio');
                        return false;
                    }

                    if (this.evento?.solicitar_datos && payload.datos_compradores?.asientos) {
                        for (let i = 0; i < payload.datos_compradores.asientos.length; i++) {
                            const asiento = payload.datos_compradores.asientos[i];
                            if (!asiento.telefono || asiento.telefono.trim() === '') {
                                this.$toast.error(`El teléfono de la invitación Nº ${i + 1} es obligatorio`);
                                return false;
                            }
                        }
                    }
                    return true;
                };

                if (!validarTelefonos()) {
                    return;
                }

                this.abonado = { ...datos_abonado };

                this.$store.dispatch('BACK_ABONADOS_INVITACIONES_GUARDAR_DATOS_COMPRADOR', payload)
                    .then(res => {                 
                        this.$toast.success('Datos guardados correctamente');          
                    })
                    .catch(error => {
                        this.$toast.error(error?.response?.data?.message || 'Error al guardar los datos');
                    });
            },
            detectarTipoDocumento(valor) {
                if (/^[XYZ]\d{7}[A-Z]$/.test(valor)) {
                    return { type: "NIE", value: "" };
                }

                if (/^\d{8}[A-Z]$/.test(valor)) {
                    return { type: "DNI", value: "" };
                }

                if (/^[A-HJ-NP-SUVW]\d{7}[0-9A-J]$/.test(valor)) {
                    return { type: "NIF", value: "" };
                }

                return { type: "PASAPORTE", value: "" };
            },
            calcularEdad(fechaNacimiento) {
                if (!fechaNacimiento) return '';
                
                const hoy = new Date();
                const nacimiento = new Date(fechaNacimiento);
                let edad = hoy.getFullYear() - nacimiento.getFullYear();
                
                const mesActual = hoy.getMonth();
                const mesNacimiento = nacimiento.getMonth();
                
                if (mesActual < mesNacimiento || (mesActual === mesNacimiento && hoy.getDate() < nacimiento.getDate())) {
                    edad--;
                }
                
                return edad.toString();
            },
            borrarSesionAndCambiarPaso() {
                if (this.session_id) {
                    this.$store.dispatch(this.config.getVuexAlias('front.sesion.delete'), { session_id: this.session_id }).finally(() => {
                        this.asientos = [];
                        this.session_id = null;
                    });
                }
            },
            procesarCompraPrecioCero(terminosYCondiciones) {
                const params = {
                    filters: {},
                    abonado_id: this.abono_id,
                    evento_id: this.event_id,
                    sesion_id: Number(this.sesion_id),
                    session_id: this.session_id,
                    privacidad: terminosYCondiciones?.privacidad ? 1 : 0,
                    condiciones: terminosYCondiciones?.condiciones ? 1 : 0,
                    comunicaciones : terminosYCondiciones?.comunicaciones ? 1: 0
                }

                this.$store.dispatch('BACK_ABONADOS_INVITACIONES_PROCESAR_PEDIDO', params)
                    .then(res => {
                        this.pedidoInfo = res.data
                        this.$toast.success('Invitaciones generadas correctamente');
                    })
                    .catch(error => {
                        this.$toast.error(error?.response?.data?.message || 'Error al procesar la compra');
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        created() {
            if (!this.teatro.invitaciones_para_abonados) {
                this.$router.go(-1);
            } else {
                this.getEvento();
                this.getAbonado();
            }
        },
        components: {
            MainContent,
            ContentOrLoading,
            Stepper,
            PasoUnoInvitaciones,
            PasoDosInvitaciones,
            PasoTresInvitaciones,
            PasoCuatroInvitaciones,
        }
    }
</script>